import { __assign } from '../_virtual/_tslib.js';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import ToastTemplate from './Template/index.js';
import buildSpindleTheme from '../helpers/buildSpindleTheme.js';

var Toast =
/** @class */
function () {
  function Toast() {}

  Toast.initialize = function (theme, animation) {
    this.theme = theme;
    this.animation = animation;
  };

  Toast.neutral = function (content, options) {
    this.toast('neutral', content, options);
  };

  Toast.info = function (content, options) {
    this.toast('info', content, options);
  };

  Toast.success = function (content, options) {
    this.toast('success', content, options);
  };

  Toast.error = function (content, options) {
    this.toast('error', content, options);
  };

  Toast.toast = function (styleType, content, options) {
    var container = document.createElement('div');
    document.body.appendChild(container);

    var close = function close() {
      var _a;

      unmountComponentAtNode(container);
      (_a = container.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(container);
    };

    var mergeOptions = __assign(__assign({}, this.options), options || {});

    render(React.createElement(ToastTemplate, {
      styleType: styleType,
      content: content,
      options: mergeOptions,
      theme: this.theme,
      animation: this.animation
    }), container);
    setTimeout(function () {
      close();
    }, mergeOptions.inOutTime * 2 + mergeOptions.showTime);
  };

  Toast.options = {
    inOutTime: 300,
    showTime: 3500,
    bottom: 8,
    isAdjustFontSize: true
  };
  Toast.theme = buildSpindleTheme();
  return Toast;
}();

export { Toast as default };